import script from "./Highlighter.vue?vue&type=script&setup=true&lang=js"
export * from "./Highlighter.vue?vue&type=script&setup=true&lang=js"

import "./Highlighter.vue?vue&type=style&index=0&id=1d4ff502&lang=sass"

const __exports__ = script;

export default __exports__